import React from 'react';
import { GridComponent, Inject, ColumnsDirective, ColumnDirective, Search, Page } from '@syncfusion/ej2-react-grids';
import { transferLearningDatasetGrid, transferLearningDataset, transferLearningIntentDataset } from '../data/dummy';

const TransferLearningDataset = ({AItype}) => {
  const toolbarOptions = ['Search'];
  const editing = { allowDeleting: true, allowEditing: true };

  let dataset = "";
  // 감정분류or의도분류에 따라 데이터셋 다르게 부여
  if (AItype=="classifiedSentiment") {
    dataset = transferLearningDataset;
  } else if (AItype=="classifiedIntent") {
    dataset = transferLearningIntentDataset;
  }

  return (
    <div>
      <div className="m-1 md:m-1 p-1 md:p-5 bg-white rounded-3xl">
        <GridComponent
          dataSource={dataset}
          width="auto"
          editSettings={editing}
          toolbar={toolbarOptions}
        >
          <ColumnsDirective>
            {transferLearningDatasetGrid.map((item, index) => (
              <ColumnDirective key={index} {...item} />
            ))}
          </ColumnsDirective>
          <Inject services={[Search, Page]} />
        </GridComponent>
      </div>
    </div>
  );
};

export default TransferLearningDataset;
